<div class=" text-grey">
  <div class="modal-header">
    <h4 class="modal-title synchpc-primary" id="modal-title">Attach Deployment</h4>
    <i style="z-index: 1" class="bi bi-x-lg text-danger" color="warn" (click)="onClose()" title="Close"></i>
  </div>

  <div class="modal-body">
    <form [formGroup]="attachDeploymentForm" spellcheck="false" autocomplete="off">
      <mat-form-field style="width: 100%;">
        <mat-label>Select Deployment</mat-label>
        <mat-select formControlName="deploymentName"
                    (selectionChange)="deploymentChange($event.value)">
          <mat-option *ngFor="let depName of deploymentNames"
                      value="{{ depName }}">{{ depName }}</mat-option>
          <mat-option *ngIf="deploymentNames.length == 0" disabled>No Deployment Available</mat-option>
        </mat-select>
        <mat-error *ngIf='attachDeploymentForm.get("deploymentName").touched && attachDeploymentForm.get("deploymentName").errors?.required'>Required</mat-error>
      </mat-form-field>
      <mat-form-field style="width: 100%;">
        <mat-label>User Role</mat-label>
        <mat-select formControlName="userRole">
          <mat-option *ngFor='let type of types' value={{type.value}}>{{type.name}}</mat-option>
        </mat-select>
        <mat-error *ngIf='attachDeploymentForm.get("userRole").touched && attachDeploymentForm.get("userRole").errors'>Required</mat-error>
      </mat-form-field>
      <mat-form-field *ngIf="!isGroupsAccessControl && isVdi == false" style="width: 100%">
        <mat-label>Job Submit Username</mat-label>
        <input matInput
          placeholder="Job Submit Username"
          formControlName="jobSubmitUserId"
               title="User Id can be of maximum 2 to 35 characters containing alphabets, numbers, . _ -" />
      </mat-form-field>
      <mat-form-field
        *ngIf="!isGroupsAccessControl && isVdi == true"
        style="width: 100%"
      >
        <mat-label>User Session Id</mat-label>
        <input
          matInput
          placeholder="User Session Id"
          formControlName="userSessionId"
          title="User Id can be of maximum 2 to 35 characters containing alphabets, numbers, . _ -"
        />
      </mat-form-field>

      <mat-form-field *ngIf="!isGroupsAccessControl" style="width: 100%">
        <mat-label>Node Group</mat-label>
        <mat-select
          formControlName="nodeGroup"
          multiple
        >
          <mat-option
            type="checkbox"
            *ngFor="let node of groups"
            [value]="node"
            >{{ node }}</mat-option
          >
        </mat-select>
        <mat-error
          *ngIf="
            attachDeploymentForm.get('nodeGroup').touched &&
            attachDeploymentForm.get('nodeGroup').errors
          "
          >Required</mat-error
        >
      </mat-form-field>

      <mat-checkbox
        *ngIf="!isGroupsAccessControl && isVdi == false"
        formControlName="addUserToCluster"
      >
        Do you want to add user to cluster?
      </mat-checkbox>
    </form>
  </div>

  <div class="modal-footer">
    <button type="button" class="btn btn-outline-secondary" (click)="onClose()">
      Close
    </button>
    <button
      type="button"
      class="btn btn-primary"
      (click)="onSubmit(attachDeploymentForm)"
    >
      Attach
    </button>
  </div>

  <ngx-spinner
    bdColor="rgba(0,0,0,0)"
    size="default"
    zIndex="1"
    color="var(--s-primary-color)"
    type="ball-spin"
    [fullScreen]="false"
  >
    <p class="pleaseWait">Please wait ...</p>
  </ngx-spinner>
</div>
